










import { Component, Vue, Watch } from 'vue-property-decorator';
import 'splitpanes/dist/splitpanes.css';
import KanbanLists from '../components/kanban-lists.vue';

@Component({
  components: { KanbanLists },
})
export default class DimensionsView extends Vue {
  private verticalDirection = false;

  mounted(): void {
    console.log(`DimensionsView mounted`);
    this.$store.states.map(s => {
      this.verticalDirection = s.app.kanbanDirVert;
    });
  }

  @Watch('kanbanDirVert')
  kanbanDirVertUpdated(dir: boolean): void {
    this.verticalDirection = dir;
  }
}
